var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"callback-log-modal","title":"View log","size":"xl","ok-only":"","ok-title":"Ok","scrollable":""}},[_c('b-card-text',[_c('callback-log-list',{attrs:{"callback-logs":this.logs}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }